import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

const A4_WIDTH_MM = 210
const A4_HEIGHT_MM = 297
const CAPTURE_WIDTH_PX = 794
const CAPTURE_HEIGHT_PX = 1123

const preparePageForCapture = (page: HTMLElement) => {
  page.style.transform = 'none'
  page.style.width = `${CAPTURE_WIDTH_PX}px`
  page.style.height = `${CAPTURE_HEIGHT_PX}px`
  page.style.minHeight = `${CAPTURE_HEIGHT_PX}px`
  page.style.maxHeight = `${CAPTURE_HEIGHT_PX}px`
  page.style.overflow = 'hidden'
  page.style.boxShadow = 'none'
  page.style.margin = '0'
  page.style.boxSizing = 'border-box'
}

export const generateScorecardPdf = async (scorecardEl: HTMLElement, filename: string) => {
  const pages = Array.from(scorecardEl.querySelectorAll('.scorecard-page')) as HTMLElement[]
  if (pages.length === 0) {
    throw new Error('No scorecard pages found')
  }

  const pdf = new jsPDF({
    unit: 'mm',
    format: 'a4',
    orientation: 'portrait',
  })

  for (let index = 0; index < pages.length; index++) {
    const page = pages[index]
    preparePageForCapture(page)

    const canvas = await html2canvas(page, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      width: CAPTURE_WIDTH_PX,
      height: CAPTURE_HEIGHT_PX,
      windowWidth: CAPTURE_WIDTH_PX,
      windowHeight: CAPTURE_HEIGHT_PX,
      scrollX: 0,
      scrollY: -window.scrollY,
    })

    const imgData = canvas.toDataURL('image/jpeg', 0.98)
    const imgHeightMm = (canvas.height / canvas.width) * A4_WIDTH_MM
    const yOffset = imgHeightMm >= A4_HEIGHT_MM ? 0 : A4_HEIGHT_MM - imgHeightMm

    if (index > 0) {
      pdf.addPage()
    }
    pdf.addImage(imgData, 'JPEG', 0, yOffset, A4_WIDTH_MM, Math.min(imgHeightMm, A4_HEIGHT_MM))
  }

  pdf.save(filename)
}
